(function () {
	'use strict';

	if (!document.querySelector('.suntime')) {
		return;
	}

	var hidden = 'hidden';

	var ageStep = document.querySelector('.js-age-step');
	var skintypeStep = document.querySelector('.js-skintype-step');
	var uvindexStep = document.querySelector('.js-uvindex-step');
	var calculateButton = document.querySelector('.js-calculate-button');
	var loader = document.querySelector('.js-calculate-loader');
	var suntimeHeader = document.querySelector('.js-suntime-header');
	var suntimeResult = document.querySelector('.js-suntime-result');
	var ageButtons = document.querySelectorAll('.js-age-button');
	var timePicker = document.querySelector('.js-time-picker');
	var datePicker = document.querySelector('.js-date-picker');
	var locationLoader = document.querySelector('.js-location-loader');
	var resultUvIndexItems = document.querySelectorAll('.js-result-uvindex-item');
	var resultUvIndexList = document.querySelector('.js-result-uvindex-info-list');
	var serverErrorMessage = document.querySelector('.js-server-message');
	var validationMessage = document.querySelector('.js-validation-message');
	var calculateContainer = document.querySelector('.js-calculate-container');

	var selectInput = '.js-select-data';
	var select = '.select';
	var mediumWidth = '(max-width: 1024px)';
	var errorMessage = '.js-error-message';
	var errorMessageDate = '.js-error-message-date';

	var shouldCancelGeoLocation = false;

	// For datalayer push
	window.dataLayer = window.dataLayer || [];
	let hasPushedInfant;
	let hasPushedAdultYouth;
	let hasPushedSkinTypeStep;
	let hasPushedUVIndexStep;
	let hasPushedCalculateStep;

	const resetDataLayerPushStatus = function () {
		hasPushedInfant = false;
		hasPushedAdultYouth = false;
		hasPushedSkinTypeStep = false;
		hasPushedUVIndexStep = false;
		hasPushedCalculateStep = false;
	};

	const getSelectedAgeTitle = function () {
		const selectedAgeButton = ageStep.querySelector('.age-step__age-button--clicked .age-step__age-button__text');
		return selectedAgeButton ? selectedAgeButton.textContent.trim() : null;
	};

	const getSelectedSkinTypeTitle = function () {
		const skintypeId = skintypeStep.querySelector(selectInput).value;
		const selectedSkinTypeRow = skintypeStep.querySelector(`[data-select-data="${skintypeId}"]`);
		const titleElement = selectedSkinTypeRow
			? selectedSkinTypeRow.closest('.dropdown-container__item').querySelector('.dropdown-container__title')
			: null;
		return titleElement ? titleElement.textContent.trim() : null;
	};

	const getSelectedUvMethodTitle = function () {
		const selectedUvMethodButton = document.querySelector('input[name="uvindex-option"]:checked');
		const titleSpan = selectedUvMethodButton ? selectedUvMethodButton.nextElementSibling : null;
		return titleSpan ? titleSpan.textContent.trim() : null;
	};

	function pushStepTitle(target) {
		const title = target.closest('.card').querySelector('.card__heading').innerText;
		dataLayer.push({ event: 'startMinsoltid', step: title });
	}

	function pushFinalUserChoices() {
		if (!hasPushedCalculateStep) {
			const selectedAgeTitle = getSelectedAgeTitle();
			const selectedSkinTypeTitle = getSelectedSkinTypeTitle();
			const selectedUvMethodTitle = getSelectedUvMethodTitle();
			dataLayer.push({
				event: 'submitMinsoltid',
				age: selectedAgeTitle,
				sensitivity: selectedSkinTypeTitle,
				uvindex: selectedUvMethodTitle,
			});
			hasPushedCalculateStep = true;
		}
	}

	function initSunTime() {
		resetDataLayerPushStatus();
		initAgeButtons();
		initSkintypeSelectClickShowNextStep();
		initSelectDropdown();
		initCurrentTime();
		initCurrentLocation();
		initResetSuntime();
		initUVIndexAndLocationButtons();
		initCalculateResult();
	}

	// Initialize page
	initSunTime();

	/*
	Age step	 
	*/
	function initAgeButtons() {
		ageButtons.forEach(function (agebutton) {
			agebutton.addEventListener('click', function (event) {
				ageButtons.forEach(toggleColors);
				handleVisibilityForNextSteps();
				var target = event.currentTarget;

				// Data layer push logic
				const age = target.getAttribute('age-category');
				if (age === 'infant' && !hasPushedInfant) {
					dataLayer.push({ event: 'submitMinsoltidBaby', age: age });
					hasPushedInfant = true;
				} else if ((age === 'adult' || age === 'youth') && !hasPushedAdultYouth) {
					pushStepTitle(target);
					hasPushedAdultYouth = true;
				}
			});
		});

		function handleVisibilityForNextSteps() {
			var infantCard = document.querySelector('.js-infant');
			if (event.currentTarget.classList.contains('js-infant-button')) {
				infantCard.classList.remove(hidden);
				skintypeStep.classList.add(hidden);
				uvindexStep.classList.add(hidden);
				calculateContainer.classList.add(hidden);
			} else {
				infantCard.classList.add(hidden);
				skintypeStep.classList.remove(hidden);
				if (skintypeStep.querySelector(selectInput).value) {
					uvindexStep.classList.remove(hidden);
				}
				if (!uvindexStep.classList.contains(hidden)) {
					calculateContainer.classList.remove(hidden);
				}
			}
		}

		function toggleColors(button) {
			if (event.currentTarget === button) {
				button.classList.add('age-step__age-button--clicked');
				button.classList.remove('age-step__age-button--default');
			} else {
				button.classList.remove('age-step__age-button--clicked');
				button.classList.add('age-step__age-button--default');
			}
		}
	}

	function initSkintypeSelectClickShowNextStep() {
		var skintypeButtons = document.querySelectorAll('.js-skintype-button');
		skintypeButtons.forEach(function (button) {
			button.addEventListener('click', function (event) {
				//Data layer push
				if (!hasPushedSkinTypeStep) {
					pushStepTitle(event.currentTarget);
					hasPushedSkinTypeStep = true;
				}

				uvindexStep.classList.remove(hidden);
				calculateButton.classList.remove(hidden);
			});
		});
	}

	function initSelectDropdown() {
		var dropdownMobileCloseButtons = document.querySelectorAll('.js-dropdown-mobile-close');
		var dropdownListItemButtons = document.querySelectorAll('.js-dropdown-listitem-button');

		var dropdownButton = '.js-dropdown-button';
		var dropdownContainer = '.dropdown-container';

		initClosing();
		initClickingItem();
		initShowingDropdown();

		function initClosing() {
			dropdownMobileCloseButtons.forEach(function (button) {
				button.addEventListener('click', handleDropdownClose);
			});
			dropdownListItemButtons.forEach(function (button) {
				button.addEventListener('click', handleDropdownClose);
			});
		}

		function handleDropdownClose(event) {
			var target = event.currentTarget;
			target.closest(select).querySelector(dropdownButton).removeAttribute('aria-pressed');

			var closestDropdownContainer = target.closest(dropdownContainer);
			if (window.matchMedia(mediumWidth).matches) {
				target.closest(dropdownContainer).addEventListener(
					'animationend',
					function (event) {
						event.currentTarget.style.display = 'none';
					},
					{ once: true }
				);
			} else {
				closestDropdownContainer.style.display = 'none';
			}

			closestDropdownContainer.classList.remove('dropdown-container__show');
			closestDropdownContainer.classList.add('dropdown-container__hide');
		}

		function initClickingItem() {
			dropdownListItemButtons.forEach(function (button) {
				button.addEventListener('click', function (event) {
					var target = event.currentTarget;
					var closestSelect = target.closest(select);
					if (target.parentElement && target.parentElement.classList.contains('uvindex-list-item')) {
						if (!hasPushedUVIndexStep) {
							pushStepTitle(target);
							hasPushedUVIndexStep = true;
						}
					}
					var text = target.getAttribute('data-dropdown-text');
					closestSelect.querySelector('.js-dropdown-button-text').textContent = text;
					var data = target.querySelector('.js-dropdown-listitem-data').getAttribute('data-select-data');
					closestSelect.querySelector('.js-select-data').value = data;
				});
			});

			var locationButtons = document.querySelectorAll('.js-dropdown-listitem-location-button');
			locationButtons.forEach(function (button) {
				button.addEventListener('click', function (event) {
					var target = event.currentTarget;
					if (!hasPushedUVIndexStep) {
						pushStepTitle(target);
						hasPushedUVIndexStep = true;
					}
					shouldCancelGeoLocation = true;
					locationLoader.classList.add(hidden);
				});
			});
		}

		function focusLocation(evt) {
			var locationButtons = document.querySelectorAll('.js-dropdown-listitem-location-button');
			for (var button of locationButtons) {
				if (evt.key.toLowerCase() === button.getAttribute('data-dropdown-text').charAt(0).toLowerCase()) {
					button.focus();
					break;
				}
			}
		}

		function initShowingDropdown() {
			var dropdownButtons = document.querySelectorAll(dropdownButton);
			dropdownButtons.forEach(function (button) {
				button.addEventListener('click', function (event) {
					var target = event.currentTarget;
					var dropdown = target.parentNode.querySelector(dropdownContainer);
					dropdown.classList.remove('dropdown-container__hide');
					dropdown.classList.add('dropdown-container__show');
					// Add focus on location when pressing a key
					var isExpanded = dropdown.getAttribute('aria-expanded');
					document.addEventListener('keypress', focusLocation);
					if (isExpanded === 'true') {
						document.removeEventListener('keypress', focusLocation);
					}
				});
			});
		}
	}

	function initUVIndexAndLocationButtons() {
		var locationButton = document.querySelector('.js-location-button');
		var uvindexButton = document.querySelector('.js-uvindex-button');
		var label = 'label';

		var locationTimeContainer = document.querySelector('.js-location-time-container');
		var uvindexSelect = document.querySelector('.js-uvindex-select');

		uvindexButton.addEventListener('click', function (event) {
			locationTimeContainer.classList.add(hidden);
			uvindexSelect.classList.remove(hidden);

			event.currentTarget.closest(label).classList.remove('uvindexstep-buttons__button--unchecked');
			locationButton.closest(label).classList.add('uvindexstep-buttons__button--unchecked');

			validationMessage.classList.add(hidden);
		});

		locationButton.addEventListener('click', function (event) {
			locationTimeContainer.classList.remove(hidden);
			uvindexSelect.classList.add(hidden);
			event.currentTarget.closest(label).classList.remove('uvindexstep-buttons__button--unchecked');
			uvindexButton.closest(label).classList.add('uvindexstep-buttons__button--unchecked');
			validationMessage.classList.add(hidden);
		});
	}

	function initCurrentTime() {
		var date = new Date();
		var hour = date.getHours();
		var minutes = date.getMinutes();

		hour = minutes >= 30 ? hour + 1 : hour;

		var selectValue = hour;
		if (hour < 8) {
			selectValue = 8;
		} else if (hour > 18) {
			selectValue = 18;
		}

		timePicker.value = selectValue;
	}

	function initCurrentLocation() {
		if (navigator.geolocation && location.protocol === 'https:') {
			var currentLocationListItem = document.querySelector('.js-geolocation');
			currentLocationListItem.classList.remove(hidden);
			var currentLocationButton = currentLocationListItem.firstElementChild;

			currentLocationButton.addEventListener('click', function (event) {
				shouldCancelGeoLocation = false;
				var target = event.currentTarget;
				var closestSelect = target.closest(select);
				var input = closestSelect.querySelector('.js-select-data');
				var dropdownText = closestSelect.querySelector('.js-dropdown-button-text');

				var loading = setTimeout(function () {
					dropdownText.textContent = target.getAttribute('data-loading-text');
					locationLoader.classList.remove(hidden);
				}, 50);

				navigator.geolocation.getCurrentPosition(
					function (location) {
						if (shouldCancelGeoLocation) return;
						var latitude = location.coords.latitude;
						input.value = latitude;
						clearTimeout(loading);
						dropdownText.textContent = target.getAttribute('data-dropdown-text');
						locationLoader.classList.add(hidden);
					},
					function (error) {
						input.value = '';
						dropdownText.textContent = dropdownText.getAttribute('data-text');
						document.querySelector('.js-geolocation-error').classList.remove(hidden);
					},
					{ timeout: 5000 }
				);
			});
		}
	}

	function initCalculateResult() {
		calculateButton.addEventListener('click', function () {
			var selectedOption = document.querySelector('input[name=uvindex-option]:checked').value;
			var url = location.origin + '/api/v1/suntime/';
			var data = {};

			var skintypeId = skintypeStep.querySelector(selectInput).value;
			//Validate inputs
			//If an input is not chosen then set errors and return
			var error = false;
			if (!skintypeId) {
				error = true;
				skintypeStep.querySelector(errorMessage).classList.remove(hidden);
			} else {
				data.skintypeId = skintypeId;
			}

			if (selectedOption === 'uvindex') {
				var uvindexValue = document.querySelector('.js-uvindex-select-input').value;
				if (!uvindexValue) {
					document.querySelector('.js-uvindex-select').querySelector(errorMessage).classList.remove(hidden);
					validationMessage.classList.remove(hidden);
					return;
				} else {
					url += 'calculatewithindex';
					data.uvIndex = uvindexValue;
				}
			} else {
				var latitude = document.querySelector('.js-location-select-input');

				var inputData = [];
				inputData.push(latitude, timePicker, datePicker);

				inputData.forEach(function (data) {
					if (!data.value) {
						error = true;
						data.parentNode.querySelector(errorMessage).classList.remove(hidden);
						if (datePicker) {
							datePicker.setAttribute('aria-invalid', true);
						}
					} else {
						data.parentNode.querySelector(errorMessage).classList.add(hidden);
						if (datePicker) {
							var regEx = /^\d{4}-\d{2}-\d{2}$/;
							var errorMessageElem = datePicker.parentNode.querySelector(errorMessageDate);

							if (!datePicker.value.match(regEx)) {
								errorMessageElem.classList.remove(hidden);
								error = true;
							} else {
								errorMessageElem.classList.add(hidden);
							}
							datePicker.setAttribute('aria-invalid', false);
						}
					}
				});

				if (error) {
					validationMessage.classList.remove(hidden);
					return;
				} else {
					url += 'calculate';
					//The latitude is formated with , and the api wants .
					data.latitude = latitude.value.replace(',', '.');
					data.dateStr = datePicker.value;
					data.hour = timePicker.value;
				}
			}

			var xhr = new XMLHttpRequest();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.onreadystatechange = function () {
				hideLoader();
				if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
					serverErrorMessage.classList.add(hidden);

					var result = JSON.parse(xhr.response).result;

					ageStep.classList.add(hidden);
					skintypeStep.classList.add(hidden);
					uvindexStep.classList.add(hidden);
					calculateButton.classList.add(hidden);
					suntimeHeader.classList.add(hidden);
					suntimeResult.classList.remove(hidden);

					document.querySelector('.js-result-description').innerHTML = result.resultDescription;

					var safeTime = document.querySelectorAll('.js-safetime');
					var safeTimeRest = document.querySelectorAll('.js-safetime-rest');
					var safeTimeDescription = document.querySelectorAll('.js-safetime-description');
					var safeTimeHours = document.querySelectorAll('.js-safetime-hours');
					var safeTimeMinutes = document.querySelectorAll('.js-safetime-minutes');
					result.safeTimeResults.forEach(function (safetimeResult, index) {
						safeTimeDescription[index].textContent = safetimeResult.shadowDescription;

						if (safetimeResult.restOfDay) {
							safeTimeRest[index].textContent = safetimeResult.safeTimeFormatted;
							safeTime[index].classList.add(hidden);
							safeTimeRest[index].classList.remove(hidden);
						} else {
							safeTimeHours[index].textContent = safetimeResult.safeTimeHours;
							safeTimeMinutes[index].textContent = safetimeResult.safeTimeMinutes;
							safeTimeRest[index].classList.add(hidden);
							safeTime[index].classList.remove(hidden);
						}
					});

					var resultUvIndex = document.querySelector('.js-result-uvindex');
					resultUvIndex.textContent = result.uvIndex;

					var resultUvIndexItem;
					if (result.uvIndex > 11) {
						resultUvIndexItem = resultUvIndexItems[resultUvIndexItems.length - 1];
					} else if (result.uvIndex > 0) {
						resultUvIndexItem = resultUvIndexItems[result.uvIndex - 1];
					}

					if (resultUvIndexItem) {
						resultUvIndexItem
							.querySelector('.js-result-uvindex-value')
							.classList.add('result__uvindex-info-index--focused');
						resultUvIndexItem.querySelector('.js-result-uvindex-triangle').classList.remove('hidden-visibility');
					}

					//scroll the horizontal bar on mobilve views
					if (resultUvIndexList.scrollWidth > resultUvIndexList.clientWidth) {
						if (result.uvIndex > 7) {
							resultUvIndexList.scrollBy(resultUvIndexList.scrollWidth, 0);
						} else {
							resultUvIndexList.scroll(0, 0);
						}
					}

					suntimeResult.scrollIntoView({ behavior: 'smooth' });
				} else {
					serverErrorMessage.classList.remove(hidden);
				}
			};

			function hideLoader() {
				loader.classList.add(hidden);
				loader.removeAttribute('disabled');
			}

			function beforeSend() {
				loader.classList.remove(hidden);
				loader.setAttribute('disabled', '');

				validationMessage.classList.add(hidden);
				serverErrorMessage.classList.add(hidden);
			}

			beforeSend();
			pushFinalUserChoices();
			xhr.send(JSON.stringify(data));
		});
	}

	function initResetSuntime() {
		document.querySelector('.js-reset-suntime').addEventListener('click', function () {
			dataLayer.push({ event: 'clickSoltid' });
			resetDataLayerPushStatus();
			suntimeResult.classList.add(hidden);
			calculateButton.classList.add(hidden);
			ageStep.classList.remove(hidden);
			suntimeHeader.classList.remove(hidden);

			ageButtons.forEach(function (agebutton) {
				agebutton.classList.remove('age-step__age-button--clicked');
				agebutton.classList.add('age-step__age-button--default');
			});

			//reset dropdowns
			var inputs = document.querySelectorAll(selectInput);
			inputs.forEach(function (input) {
				input.value = '';
			});

			var dropdownTexts = document.querySelectorAll('.js-dropdown-button-text');
			dropdownTexts.forEach(function (text) {
				text.textContent = text.getAttribute('data-text');
			});

			//reset time and date
			datePicker.value = datePicker.getAttribute('data-original-value');

			// Reset data layer push variables
			initCurrentTime();

			//result uvindex list
			resultUvIndexItems.forEach(function (item) {
				item.querySelector('.js-result-uvindex-triangle').classList.add('hidden-visibility');
				item.querySelector('.js-result-uvindex-value').classList.remove('result__uvindex-info-index--focused');
			});

			//hide error messages
			var errorMessages = document.querySelectorAll(errorMessage);
			errorMessages.forEach(function (message) {
				message.classList.add(hidden);
			});

			document.querySelector('.suntime').scrollIntoView({ behavior: 'smooth' });
		});
	}
})();
